<!--  -->
<template>
  <div
    class="container"
    style="background-color: white"
    id="container"
    v-title
    data-title="出版物许可"
  >
    <linglanHeader :isLogin="true"></linglanHeader>
    <div class="content">
      <img style="max-width: 880px" src="@/assets/pdf/pdf1.jpg" alt="" />
      <img style="max-width: 880px" src="@/assets/pdf/pdf2.jpg" alt="" />
    </div>
    <div class="footer-wraper">
      <div class="footer">
        <div class="img-wraper fl">
          <img src="@/assets/images/download.jpg" alt="" />
        </div>
        <div class="info fl">
          <p>
            为了保护您的听课权益，本网站不支持与APP端、H5端同时在线，三端有且只能一端在线。如您在APP或H5端再次登录，PC端将自动退出登录。
          </p>
          <b>咨询建议请扫描二维码添加客服企业微信</b>
        </div>
        <div class="copyright fr">
          © 2017 北京灵兰精诚中医科技有限公司版权所有<br />京ICP备15057334号
          <router-link tag="a" target="_blank" :to="{ name: 'privacyPolicy' }"
            ><span style="margin-left: 15px">隐私及个人信息保护政策</span></router-link
          >
          <br />
          <router-link tag="a" target="_blank" :to="{ name: 'permit' }"
            >出版物许可</router-link
          >
        </div>
        <div class="line fr"></div>
      </div>
    </div>
  </div>
</template>

<script>
import linglanHeader from "@/components/header";
export default {
  components: {
    linglanHeader,
  },
  data() {
    return {};
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
/* @import url(); 引入css类 */
@import url("../../assets/css/common.css");
@import url("../../assets/css/main.css");
@import url("../../assets/css/free.css");
page {
  background-color: white;
}
#app,
body {
  background-color: white;
}
.content {
  max-width: 880px;
  margin: 0 auto;
  background-color: white;
}
h1 {
  clear: left;
  margin-top: 2.33333em;
  margin-bottom: 1.16667em;
  font-size: 1.2em;
  line-height: 1.5;
  font-weight: 600;
  font-synthesis: style;
  text-align: center;
}
.line-height-30 {
  line-height: 30px;
}
</style>
